// 主题切换 —— light / dark / system 三态, 写 documentElement.data-theme
//
// 持久化: localStorage["chatbox.theme"] = "light" | "dark" | "system"
// 未设 = "system" (跟随 prefers-color-scheme)

export type ThemeMode = "light" | "dark" | "system";

const KEY = "chatbox.theme";

export function readTheme(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark") return v;
  } catch {
    /* private mode */
  }
  return "system";
}

export function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement;
  if (mode === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", mode);
  try {
    if (mode === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, mode);
  } catch {
    /* ignore */
  }
}

/** 启动时立即调一次, 避免闪烁。 */
export function initTheme(): void {
  applyTheme(readTheme());
}

/** 拿当前实际生效的色调（resolved），用于按钮 label 显示。 */
export function resolvedTheme(): "light" | "dark" {
  const m = readTheme();
  if (m !== "system") return m;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
